import { render, staticRenderFns } from "./RevsSection.vue?vue&type=template&id=6e036631&scoped=true"
import script from "./RevsSection.vue?vue&type=script&lang=js"
export * from "./RevsSection.vue?vue&type=script&lang=js"
import style0 from "./RevsSection.vue?vue&type=style&index=0&id=6e036631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e036631",
  null
  
)

export default component.exports